import axios from 'axios';
import BaseAPI from './base/base-api';

class EmailReceiveAlertAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'emailreceivealert';
}

export default new EmailReceiveAlertAPI();